// import React, { useState, useRef, useEffect } from "react";
// import { ResizableBox } from "react-resizable";
// // import 'react-resizable/css/styles.css'; // Import default styles
// import "../pg.css";
// import { FaRotate } from "react-icons/fa6";

// const ResizableImage2 = ({ src, color, sendMessage, initialPosition }) => {
//   const [imageSize, setImageSize] = useState({ width: 100, height: 100 });
//   // const [position, setPosition] = useState({ x: 115, y: 130 }); // Position of image (for dragging)
//   const [position, setPosition] = useState(initialPosition); // Position of image (for dragging)
//   const [isDragging, setIsDragging] = useState(false); // Track dragging state
//   const [isResizing, setIsResizing] = useState(false); // Track resizing state
//   const [handlesVisible, setHandlesVisible] = useState(false); // Track visibility of resize handles
//   const [isTouchDevice, setIsTouchDevice] = useState(false); // Detect touch device for better touch handling
//   const [rotation, setRotation] = useState(0);

//   const wrapperRef = useRef(null); // Ref for the wrapper div
//   const dragStartPosition = useRef({ x: 0, y: 0 }); // Store initial position when dragging starts
//   const resizeStart = useRef({ width: 0, height: 0, x: 0, y: 0 }); // Store initial resize data
//   const [isRotating, setIsRotating] = useState(false);
//   const rotationStart = useRef(0);
//   const [textColor, setTextColor] = useState("");
//   const [signColor, setSignColor] = useState("");

//   // Utility to get the correct client position (mouse or touch)
//   const getClientPosition = (e) => {
//     if (e.type.startsWith("touch")) {
//       return { x: e.touches[0].clientX, y: e.touches[0].clientY }; // For touch
//     } else {
//       return { x: e.clientX, y: e.clientY }; // For mouse
//     }
//   };

//   // Detect if the device is a touch device
//   useEffect(() => {
//     if ("ontouchstart" in window || navigator.maxTouchPoints > 0) {
//       setIsTouchDevice(true);
//     }
//   }, []);

//   // Handle resize logic
//   const handleResize = (e, data) => {
//     setImageSize({ width: data.size.width, height: data.size.height });
//   };

//   // Handle click outside the resizable image to hide the handles
//   const handleClickOutside = (event) => {
//     if (
//       wrapperRef.current &&
//       !wrapperRef.current.contains(event.target) &&
//       !isResizing
//     ) {
//       setHandlesVisible(false);
//     }
//   };

//   // Handle mouse or touch start to begin dragging
//   const handleMouseOrTouchStart = (event) => {
//     if (!handlesVisible) return;
//     if (!isResizing && !isRotating) {
//       // Only allow dragging if not resizing and not rotating
//       setIsDragging(true);
//       const { x, y } = getClientPosition(event);
//       dragStartPosition.current = { x: x - position.x, y: y - position.y };
//     }
//   };

//   // Handle mouse or touch move to update the position when dragging
//   const handleMouseOrTouchMove = (event) => {
//     if (isDragging && !isResizing && !isRotating) {
//       // Only update position if not resizing
//       const { x, y } = getClientPosition(event);
//       setPosition({
//         x: x - dragStartPosition.current.x,
//         y: y - dragStartPosition.current.y,
//       });
//     }

//     // Prevent scrolling during touch move if resizing or dragging
//     if (isTouchDevice && (isDragging || isResizing)) {
//       event.preventDefault(); // Prevent scroll
//     }

//     if (isRotating) {
//       const { x, y } = getClientPosition(event);
//       const rect = wrapperRef.current.getBoundingClientRect();
//       const centerX = rect.left + rect.width / 2;
//       const centerY = rect.top + rect.height / 2;

//       const angle = Math.atan2(y - centerY, x - centerX) * (180 / Math.PI);
//       setRotation(rotationStart.current + angle);
//     }
//   };

//   // Handle mouse or touch end to stop dragging or resizing
//   const handleMouseOrTouchEnd = () => {
//     setIsDragging(false); // Stop dragging when the touch or mouse button is released
//     setIsResizing(false);
//     setIsRotating(false);
//   };

//   const handleRotateStart = (e) => {
//     e.stopPropagation(); // Prevent drag start when rotating
//     setIsRotating(true);
//     const { x, y } = getClientPosition(e);
//     const rect = wrapperRef.current.getBoundingClientRect();
//     const centerX = rect.left + rect.width / 2;
//     const centerY = rect.top + rect.height / 2;

//     const angle = Math.atan2(y - centerY, x - centerX) * (180 / Math.PI);
//     rotationStart.current = rotation - angle;
//   };

//   // Handle resize start event for touch
//   const handleResizeStart = (e) => {
//     setIsResizing(true);
//     setHandlesVisible(true); // Ensure handles remain visible during resizing
//     const { x, y } = getClientPosition(e);
//     resizeStart.current = {
//       width: imageSize.width,
//       height: imageSize.height,
//       x,
//       y,
//     };
//   };

//   // Handle resize stop event
//   const handleResizeStop = () => {
//     setIsResizing(false);
//     sendDataToParent();
//   };

//   // Handle touch move for resizing
//   const handleTouchResize = (e) => {
//     // inja
//     // setIsResizing(true);
//     //
//     const { x, y } = getClientPosition(e);

//     const deltaX = x - resizeStart.current.x;
//     const deltaY = y - resizeStart.current.y;

//     const newWidth = resizeStart.current.width + deltaX;
//     const newHeight = resizeStart.current.height + deltaY;

//     // setImageSize({
//     //   width: Math.max(50, Math.min(newWidth, 200)),
//     //   height: Math.max(50, Math.min(newHeight, 200)),
//     // });
//   };

//   useEffect(() => {
//     // console.log(color)
//     // if(color.toLowerCase()==="white"|| color.toLowerCase().includes("light")){
//     setTextColor("black");
//     setSignColor("red");
//     //     }
//     //     else{
//     //     setTextColor("white")
//     //     }
//     //  if(color.toLowerCase()==="red"|| color.toLowerCase().includes("red")){
//     //  setSignColor("white")
//     //  }
//     //  else{
//     //    setSignColor("red")
//     //    }
//     if (isDragging || isResizing || isRotating) {
//       // Prevent default scroll behavior for touch devices while dragging or resizing
//       document.body.style.overflow = "hidden"; // Prevent page scroll
//       document.addEventListener("touchmove", handleMouseOrTouchMove, {
//         passive: false,
//       });
//       document.addEventListener("touchend", handleMouseOrTouchEnd);
//       // inja- If resizing, listen for touch resizing events
//       // if (isResizing) {
//       // document.addEventListener('touchmove', handleTouchResize, { passive: false });
//       // }
//       //
//     } else {
//       document.body.style.overflow = ""; // Re-enable scrolling after drag/resizing/rotating
//       document.removeEventListener("touchmove", handleMouseOrTouchMove);
//       document.removeEventListener("touchend", handleMouseOrTouchEnd);
//       // inja
//       // document.removeEventListener('touchmove', handleTouchResize);
//     }

//     // Mouse-based events
//     if (isDragging || isResizing || isRotating) {
//       document.addEventListener("mousemove", handleMouseOrTouchMove);
//       document.addEventListener("mouseup", handleMouseOrTouchEnd);
//     } else {
//       document.removeEventListener("mousemove", handleMouseOrTouchMove);
//       document.removeEventListener("mouseup", handleMouseOrTouchEnd);
//     }

//     return () => {
//       document.body.style.overflow = ""; // Ensure scrolling is re-enabled on cleanup
//       document.removeEventListener("touchmove", handleMouseOrTouchMove);
//       document.removeEventListener("touchend", handleMouseOrTouchEnd);
//       document.removeEventListener("mousemove", handleMouseOrTouchMove);
//       document.removeEventListener("mouseup", handleMouseOrTouchEnd);
//       // inja
//       // document.removeEventListener('touchmove', handleTouchResize);
//       //
//     };
//   }, [isDragging, isResizing, isRotating]);

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     document.addEventListener("touchstart", handleClickOutside, {
//       passive: true,
//     });
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//       document.removeEventListener("touchstart", handleClickOutside);
//     };
//   }, []);

//   // Helper function to render red dots around the image
//   const renderRedDots = () => {
//     const positions = [
//       { top: 0, left: 0 }, // top-left
//       { top: 0, left: imageSize.width - 10 }, // top-right
//       { top: imageSize.height - 10, left: 0 }, // bottom-left
//       { top: imageSize.height - 10, left: imageSize.width - 10 }, // bottom-right
//     ];

//     return positions.map((pos, index) => (
//       <div
//         key={index}
//         style={{
//           position: "absolute",
//           top: pos.top + "px",
//           left: pos.left + "px",
//           // width: '10px',
//           // height: '10px',
//           backgroundColor: signColor,
//           // borderRadius: '50%',
//           cursor: "pointer", // Arrows when resizing, else circles
//           zIndex: 10, // Ensure the dots are on top of the image
//         }}
//         onMouseDown={(e) => {
//           e.preventDefault();
//           setIsResizing(true);
//         }}
//         onTouchStart={(e) => {
//           e.preventDefault();
//           setIsResizing(true);
//         }}
//       />
//     ));
//   };

//   const renderRotateHandle = () => {
//     return (
//       <div
//         style={{
//           position: "absolute",
//           top: "-30px",
//           left: `${imageSize.width / 2 - 10}px`,
//           width: "20px",
//           height: "20px",
//           borderRadius: "50%",
//           cursor: "grab",
//           zIndex: 10,
//         }}
//         onMouseDown={handleRotateStart}
//         onTouchStart={handleRotateStart}
//       >
//         <FaRotate style={{ color: signColor }} />
//       </div>
//     );
//   };
//   // document.querySelector("#myImage > div > div.react-resizable > span.react-resizable-handle.react-resizable-handle-ne").style.color="red"
//   const sendDataToParent = () => {
//     // sendMessage(((imageSize.width)/72*4).toFixed(2)*((imageSize.height)/72*4).toFixed(2));
//     const widthInches = (imageSize.width / 72) * 4;
//     const heightInches = (imageSize.height / 72) * 4;
//     const area = widthInches * heightInches;
//     sendMessage({
//       width: imageSize.width,
//       height: imageSize.height,
//       widthInches: parseFloat(widthInches.toFixed(2)),
//       heightInches: parseFloat(heightInches.toFixed(2)),
//       area: parseFloat(area.toFixed(2)),
//     });

//     setHandlesVisible(!handlesVisible);
//   };
//   return (
//     <div
//       ref={wrapperRef}
//       onMouseDown={handleMouseOrTouchStart} // Start dragging on mouse down
//       onTouchStart={handleMouseOrTouchStart} // Start dragging on touch start
//       onClick={sendDataToParent} // Show handles when clicking on the image
//       style={{
//         position: "absolute", // Position the image absolutely inside its container
//         top: position.y + "px", // Position of image when dragged
//         left: position.x + "px", // Position of image when dragged
//         transform: `rotate(${rotation}deg)`,
//         cursor: isDragging ? "grabbing" : "grab", // Change cursor when dragging
//         zIndex: 0, // Ensure the image is below the dots
//       }}
//     >
//       {/* <ResizableBox
//         width={imageSize.width}
//         height={imageSize.height}
//         axis="both"
//         minConstraints={[50, 50]}
//         maxConstraints={[200, 200]}
//         onResize={handleResize}
//         resizeHandles={handlesVisible ? ['se', 'sw', 'ne', 'nw'] : []} // Show handles based on state
//         onResizeStart={handleResizeStart} // Set resizing state to true on resize start
//         onResizeStop={handleResizeStop} // Set resizing state to false when resize stops
//         onClick={ sendDataToParent}
//         style={{
//           borderRadius: '8px',
//           position: 'relative', // Keep the resizing box positioned relatively inside the wrapper
//         }}
//       >
//         <img
//           src={src}
//           alt="Resizable"
//           style={{
//             width: '100%',
//             height: '100%',
//             objectFit: 'cover',
//             borderRadius: '8px',
//           }}
//         />
//         {handlesVisible && (
//           <div style={{ color: textColor,marginTop:5, border:"1px solid red", borderRadius: "5px", padding: "5px",backgroundColor:"grey"}}>
//             <p style={{marginBottom:20}}>Est. Size:</p>
//             <hr style={{ marginTop: -20 , color:"white",marginBottom:20 }}/>
//             <p style={{ marginTop: -20 }}>W: {((imageSize.width)/72*4).toFixed(1)}"</p>
//             <p style={{ marginTop: -20 }}>H: {((imageSize.height)/72*4).toFixed(1)}"</p>
//             <p style={{ marginTop: -20 }}>∠: {rotation.toFixed(2)}&deg; </p>
//           </div>
//         )}
//       </ResizableBox> */}
//       <ResizableBox
//         width={imageSize.width}
//         height={imageSize.height}
//         axis="both"
//         minConstraints={[50, 50]}
//         maxConstraints={[600, 600]}
//         onResize={handleResize}
//         resizeHandles={handlesVisible ? ["se", "sw", "ne", "nw"] : []}
//         onResizeStart={handleResizeStart}
//         onResizeStop={handleResizeStop}
//         onClick={sendDataToParent}
//         style={{
//           borderRadius: "8px",
//           position: "relative",
//         }}
//       >
//         <div style={{ width: "100%", height: "100%", position: "relative" }}>
//           <img
//             src={src}
//             alt="No Preview"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               borderRadius: "8px",
//             }}
//           />
//           {/* {handlesVisible && (
//       <div style={{ color: textColor, marginTop: 5, border: "1px solid red", borderRadius: "5px", padding: "5px", backgroundColor: "grey", position: "absolute", bottom: 0, left: 0 }}>
//         <p style={{ marginBottom: 20 }}>Est. Size:</p>
//         <hr style={{ marginTop: -20, color: "white", marginBottom: 20 }} />
//         <p style={{ marginTop: -20 }}>W: {((imageSize.width) / 72 * 4).toFixed(1)}"</p>
//         <p style={{ marginTop: -20 }}>H: {((imageSize.height) / 72 * 4).toFixed(1)}"</p>
//         <p style={{ marginTop: -20 }}>∠: {rotation.toFixed(2)}&deg;</p>
//       </div>
//     )} */}
//         </div>
//       </ResizableBox>

//       {
//         handlesVisible
//         //  && renderRedDots()
//       }
//       {handlesVisible && renderRotateHandle()}
//     </div>
//   );
// };

// export default ResizableImage2;

import React, { useState, useRef, useEffect } from "react";
import { ResizableBox } from "react-resizable";
// import 'react-resizable/css/styles.css'; // Import default styles
import "../pg.css";
import { FaRotate } from "react-icons/fa6";

const ResizableImage2 = ({ src, color, sendMessage, initialPosition }) => {
  const [imageSize, setImageSize] = useState({ width: 100, height: 100 });
  // const [position, setPosition] = useState({ x: 115, y: 130 }); // Position of image (for dragging)
  const [position, setPosition] = useState(initialPosition); // Position of image (for dragging)
  const [isDragging, setIsDragging] = useState(false); // Track dragging state
  const [isResizing, setIsResizing] = useState(false); // Track resizing state
  const [handlesVisible, setHandlesVisible] = useState(false); // Track visibility of resize handles
  const [isTouchDevice, setIsTouchDevice] = useState(false); // Detect touch device for better touch handling
  const [rotation, setRotation] = useState(0);
  // const wrapperRef = useRef(null); // Ref for the wrapper div
  // 🔥 NEW
  const [removeBg, setRemoveBg] = useState(true);
  const [processedSrc, setProcessedSrc] = useState(src);
const [showControls, setShowControls] = useState(true);
  const wrapperRef = useRef(null);
  const dragStartPosition = useRef({ x: 0, y: 0 });
  const resizeStart = useRef({ width: 0, height: 0, x: 0, y: 0 });

  const [isRotating, setIsRotating] = useState(false);
  const rotationStart = useRef(0);
  const [textColor, setTextColor] = useState("");
  const [signColor, setSignColor] = useState("");

  // =========================
  // 🔥 BACKGROUND REMOVAL
  // =========================
  const processImage = (imageUrl) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imageUrl;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.width;
      canvas.height = img.height;

      ctx.drawImage(img, 0, 0);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      let whiteCount = 0;
      let blackCount = 0;

      for (let i = 0; i < data.length; i += 40) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        // if (r > 240 && g > 240 && b > 240) whiteCount++;
        // if (r < 20 && g < 20 && b < 20) blackCount++;
            if (r > 230 && g > 230 && b > 230) whiteCount++;
        if (r < 40 && g < 40 && b < 40) blackCount++;
      }

      const removeWhite = whiteCount > blackCount;

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        if (removeWhite) {
          if (r > 230 && g > 230 && b > 230) {
            data[i + 3] = 0;
          }
        } else {
          if (r < 40 && g < 40 && b < 40) {
            data[i + 3] = 0;
          }
        }
      }

      ctx.putImageData(imageData, 0, 0);
      setProcessedSrc(canvas.toDataURL("image/png"));
    };
  };

  useEffect(() => {
    if (!src) return;

    if (removeBg) {
      processImage(src);
    } else {
      setProcessedSrc(src);
    }
  }, [src, removeBg]);

  // =========================
  // EXISTING CODE
  // =========================

  const getClientPosition = (e) => {
    if (e.type.startsWith("touch")) {
      return { x: e.touches[0].clientX, y: e.touches[0].clientY }; // For touch
    } else {
      return { x: e.clientX, y: e.clientY }; // For mouse
    }
  };

  // Detect if the device is a touch device
  useEffect(() => {
    if ("ontouchstart" in window || navigator.maxTouchPoints > 0) {
      setIsTouchDevice(true);
    }
  }, []);

  // Handle resize logic
  const handleResize = (e, data) => {
    setImageSize({ width: data.size.width, height: data.size.height });
  };

  // Handle click outside the resizable image to hide the handles
  const handleClickOutside = (event) => {
    if (
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target) &&
      !isResizing
    ) {
      setHandlesVisible(false);
    }
  };

  // Handle mouse or touch start to begin dragging
  const handleMouseOrTouchStart = (event) => {
    if (!handlesVisible) return;
    if (!isResizing && !isRotating) {
      // Only allow dragging if not resizing and not rotating
      setIsDragging(true);
      const { x, y } = getClientPosition(event);
      dragStartPosition.current = { x: x - position.x, y: y - position.y };
    }
  };

  // Handle mouse or touch move to update the position when dragging
  const handleMouseOrTouchMove = (event) => {
    if (isDragging && !isResizing && !isRotating) {
      // Only update position if not resizing
      const { x, y } = getClientPosition(event);
      setPosition({
        x: x - dragStartPosition.current.x,
        y: y - dragStartPosition.current.y,
      });
    }

    // Prevent scrolling during touch move if resizing or dragging
    if (isTouchDevice && (isDragging || isResizing)) {
      event.preventDefault(); // Prevent scroll
    }

    if (isRotating) {
      const { x, y } = getClientPosition(event);
      const rect = wrapperRef.current.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const angle = Math.atan2(y - centerY, x - centerX) * (180 / Math.PI);
      setRotation(rotationStart.current + angle);
    }
  };

  // Handle mouse or touch end to stop dragging or resizing
  const handleMouseOrTouchEnd = () => {
    setIsDragging(false); // Stop dragging when the touch or mouse button is released
    setIsResizing(false);
    setIsRotating(false);
  };

  const handleRotateStart = (e) => {
    e.stopPropagation(); // Prevent drag start when rotating
    setIsRotating(true);
    const { x, y } = getClientPosition(e);
    const rect = wrapperRef.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    const angle = Math.atan2(y - centerY, x - centerX) * (180 / Math.PI);
    rotationStart.current = rotation - angle;
  };

  const handleResizeStart = (e) => {
    setIsResizing(true);
    setHandlesVisible(true);
    const { x, y } = getClientPosition(e);
    resizeStart.current = {
      width: imageSize.width,
      height: imageSize.height,
      x,
      y,
    };
  };

  const handleResizeStop = () => {
    setIsResizing(false);
    sendDataToParent();
  };

  // Handle touch move for resizing
  const handleTouchResize = (e) => {
    // inja
    // setIsResizing(true);
    //
    const { x, y } = getClientPosition(e);

    const deltaX = x - resizeStart.current.x;
    const deltaY = y - resizeStart.current.y;

    const newWidth = resizeStart.current.width + deltaX;
    const newHeight = resizeStart.current.height + deltaY;

    // setImageSize({
    //   width: Math.max(50, Math.min(newWidth, 200)),
    //   height: Math.max(50, Math.min(newHeight, 200)),
    // });
  };

  useEffect(() => {
    setTextColor("black");
    setSignColor("red");

    if (isDragging || isResizing || isRotating) {
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", handleMouseOrTouchMove, {
        passive: false,
      });
      document.addEventListener("touchend", handleMouseOrTouchEnd);
    } else {
      document.body.style.overflow = "";
      document.removeEventListener("touchmove", handleMouseOrTouchMove);
      document.removeEventListener("touchend", handleMouseOrTouchEnd);
    }

    if (isDragging || isResizing || isRotating) {
      document.addEventListener("mousemove", handleMouseOrTouchMove);
      document.addEventListener("mouseup", handleMouseOrTouchEnd);
    } else {
      document.removeEventListener("mousemove", handleMouseOrTouchMove);
      document.removeEventListener("mouseup", handleMouseOrTouchEnd);
    }

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("touchmove", handleMouseOrTouchMove);
      document.removeEventListener("touchend", handleMouseOrTouchEnd);
      document.removeEventListener("mousemove", handleMouseOrTouchMove);
      document.removeEventListener("mouseup", handleMouseOrTouchEnd);
    };
  }, [isDragging, isResizing, isRotating]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside, {
      passive: true,
    });
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  // Helper function to render red dots around the image
  const renderRedDots = () => {
    const positions = [
      { top: 0, left: 0 }, // top-left
      { top: 0, left: imageSize.width - 10 }, // top-right
      { top: imageSize.height - 10, left: 0 }, // bottom-left
      { top: imageSize.height - 10, left: imageSize.width - 10 }, // bottom-right
    ];

    return positions.map((pos, index) => (
      <div
        key={index}
        style={{
          position: "absolute",
          top: pos.top + "px",
          left: pos.left + "px",
          // width: '10px',
          // height: '10px',
          backgroundColor: signColor,
          // borderRadius: '50%',
          cursor: "pointer", // Arrows when resizing, else circles
          zIndex: 10, // Ensure the dots are on top of the image
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          setIsResizing(true);
        }}
        onTouchStart={(e) => {
          e.preventDefault();
          setIsResizing(true);
        }}
      />
    ));
  };

  const renderRotateHandle = () => {
    return (
    <div
      style={{
        position: "absolute",
        top: "-30px",
        left: `${imageSize.width / 2 - 10}px`,
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        cursor: "grab",
        zIndex: 10,
      }}
      onMouseDown={handleRotateStart}
      onTouchStart={handleRotateStart}
    >
      <FaRotate style={{ color: signColor }} />
    </div>
  );
  };
  // document.querySelector("#myImage > div > div.react-resizable > span.react-resizable-handle.react-resizable-handle-ne").style.color="red"
  const sendDataToParent = () => {
    const widthInches = (imageSize.width / 72) * 4;
    const heightInches = (imageSize.height / 72) * 4;
    const area = widthInches * heightInches;

    sendMessage({
      width: imageSize.width,
      height: imageSize.height,
      widthInches: parseFloat(widthInches.toFixed(2)),
      heightInches: parseFloat(heightInches.toFixed(2)),
      area: parseFloat(area.toFixed(2)),
    });

    setHandlesVisible(!handlesVisible);
  };

  return (
    <div
      ref={wrapperRef}
      onMouseDown={handleMouseOrTouchStart}
      onTouchStart={handleMouseOrTouchStart}
      onClick={sendDataToParent}
      style={{
        position: "absolute",
        top: position.y + "px",
        left: position.x + "px",
        transform: `rotate(${rotation}deg)`,
        cursor: isDragging ? "grabbing" : "grab",
        zIndex: 0,
      }}
    >
      {/* 🔘 Toggle */}
      {/* <div
       data-html2canvas-ignore="true" // ✅ MAGIC LINE
        style={{
          position: "absolute",
          top: "-40px",
          left: "0px",
          background: "#fff",
          padding: "4px 8px",
          borderRadius: 4,
          fontSize: 12,
          zIndex: 20,
          marginLeft:20
        }}
      >
        <label>
          <input
            type="checkbox"
            checked={removeBg}
            onChange={() => setRemoveBg(!removeBg)}
          />{" "}
          Remove BG
        </label>
      </div>

      <ResizableBox
        width={imageSize.width}
        height={imageSize.height}
        axis="both"
        minConstraints={[50, 50]}
        maxConstraints={[600, 600]}
        onResize={handleResize}
        resizeHandles={handlesVisible ? ["se", "sw", "ne", "nw"] : []}
        onResizeStart={handleResizeStart}
        onResizeStop={handleResizeStop}
        onClick={sendDataToParent}
        style={{
          borderRadius: "0px",
          position: "relative",
        }}
      >
        <div style={{ width: "100%", height: "100%", position: "relative" }}>
          <img
            src={processedSrc} // 🔥 IMPORTANT CHANGE
            alt="No Preview"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "0px",
            }}
          />
        </div>
      </ResizableBox> */}
<div style={{ display: "inline-block" }}>
  
  {/* Controls */}
  {showControls && (
    <div
      data-html2canvas-ignore="true"
      style={{
        background: "#fff",
        padding: "6px 10px",
        borderRadius: 6,
        fontSize: 12,
        marginBottom: 8, // 👈 spacing from ResizableBox
        display: "inline-block"
      }}
    >
      <label>
        <input
          type="checkbox"
          checked={removeBg}
          onChange={() => setRemoveBg(!removeBg)}
        />{" "}
        Remove BG
      </label>
    </div>
  )}
{/* <button onClick={() => setShowControls(prev => !prev)}>
  Toggle Options
</button> */}
  {/* Resizable */}
  <ResizableBox
    width={imageSize.width}
    height={imageSize.height}
    axis="both"
    minConstraints={[50, 50]}
    maxConstraints={[600, 600]}
    onResize={handleResize}
    resizeHandles={handlesVisible ? ["se", "sw", "ne", "nw"] : []}
    onResizeStart={handleResizeStart}
    onResizeStop={handleResizeStop}
    onClick={sendDataToParent}
    style={{
      borderRadius: "0px",
      position: "relative",
    }}
  >
    <div style={{ width: "100%", height: "100%" }}>
      <img
        src={processedSrc}
        alt="No Preview"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "0px",
        }}
      />
    </div>
  </ResizableBox>

</div>
      {
        handlesVisible
        //  && renderRedDots()
      }
      {handlesVisible && renderRotateHandle()}
    </div>
  );
};

export default ResizableImage2;
